// Rich sample data for the StaffLink demo modules.
// Deliberately Ghana-flavoured (Accra suburbs, Ghanaian names, GHS pricing).

export const services = [
  { id: "hair", name: "Hair Styling", duration: 60, price: 180 },
  { id: "spa", name: "Full Body Massage", duration: 90, price: 420 },
  { id: "nails", name: "Manicure & Pedicure", duration: 75, price: 220 },
  { id: "facial", name: "Signature Facial", duration: 60, price: 350 },
  { id: "makeup", name: "Bridal Makeup", duration: 120, price: 900 },
];

export const staff = [
  { id: "s1", name: "Akosua Mensah", role: "Senior Stylist", rating: 4.9 },
  { id: "s2", name: "Kwesi Boateng", role: "Massage Therapist", rating: 4.8 },
  { id: "s3", name: "Efua Owusu", role: "Nail Technician", rating: 4.9 },
  { id: "s4", name: "Nana Yaw", role: "Facialist", rating: 4.7 },
];

export const appointments = [
  { id: "a1", client: "Ama Serwaa", service: "Signature Facial", staff: "Nana Yaw", date: "2026-02-14", time: "10:00", status: "Confirmed" },
  { id: "a2", client: "Kojo Antwi", service: "Full Body Massage", staff: "Kwesi Boateng", date: "2026-02-14", time: "13:30", status: "Confirmed" },
  { id: "a3", client: "Adjoa Smith", service: "Bridal Makeup", staff: "Akosua Mensah", date: "2026-02-15", time: "08:00", status: "Pending" },
  { id: "a4", client: "Yaa Asantewaa", service: "Manicure & Pedicure", staff: "Efua Owusu", date: "2026-02-15", time: "15:00", status: "Confirmed" },
];

// Inventory
export const productCategories = ["Beverages", "Groceries", "Cosmetics", "Electronics", "Household"];
export const products = [
  { id: "p1", sku: "SL-0001", name: "Voltic Water 1.5L (Case)", category: "Beverages", price: 45, cost: 32, stock: 128, reorder: 40, barcode: "6001069011203" },
  { id: "p2", sku: "SL-0002", name: "Fanmilk Yogurt", category: "Groceries", price: 12, cost: 8, stock: 22, reorder: 30, barcode: "6001069011210" },
  { id: "p3", sku: "SL-0003", name: "Shea Butter 250g", category: "Cosmetics", price: 55, cost: 30, stock: 210, reorder: 60, barcode: "6001069011227" },
  { id: "p4", sku: "SL-0004", name: "Nasco Kettle 1.7L", category: "Electronics", price: 320, cost: 220, stock: 6, reorder: 20, barcode: "6001069011234" },
  { id: "p5", sku: "SL-0005", name: "Milo Refill 500g", category: "Groceries", price: 60, cost: 44, stock: 88, reorder: 40, barcode: "6001069011241" },
  { id: "p6", sku: "SL-0006", name: "Ghana Soap Bar", category: "Household", price: 8, cost: 4, stock: 512, reorder: 100, barcode: "6001069011258" },
  { id: "p7", sku: "SL-0007", name: "Bel Aqua 500ml (Case)", category: "Beverages", price: 30, cost: 20, stock: 14, reorder: 25, barcode: "6001069011265" },
  { id: "p8", sku: "SL-0008", name: "Ariel Detergent 1kg", category: "Household", price: 42, cost: 28, stock: 68, reorder: 30, barcode: "6001069011272" },
];

export const salesTrend = [
  { month: "Aug", revenue: 42000, orders: 210 },
  { month: "Sep", revenue: 51200, orders: 264 },
  { month: "Oct", revenue: 48800, orders: 250 },
  { month: "Nov", revenue: 61800, orders: 305 },
  { month: "Dec", revenue: 78400, orders: 402 },
  { month: "Jan", revenue: 84900, orders: 441 },
];

export const topCustomers = [
  { name: "Ohene Enterprise", spent: 42800, orders: 32 },
  { name: "Adom Supermarket", spent: 38100, orders: 28 },
  { name: "Kwabena Trading", spent: 27400, orders: 24 },
  { name: "Golden Tulip Kumasi", spent: 21100, orders: 18 },
];

// HR
export const employees = [
  { id: "e1", name: "Kofi Adjei", role: "Sales Lead", dept: "Sales", manager: "Nii Ayikwei", status: "Active", leave: 12, joined: "2024-06-01" },
  { id: "e2", name: "Abena Owusu", role: "Marketing Manager", dept: "Marketing", manager: "Ama Boateng", status: "Active", leave: 8, joined: "2023-03-14" },
  { id: "e3", name: "Yaw Boadu", role: "Support Agent", dept: "Support", manager: "Kwame Nkrumah", status: "Onboarding", leave: 15, joined: "2026-02-10" },
  { id: "e4", name: "Esi Danquah", role: "Accountant", dept: "Finance", manager: "Kojo Aidoo", status: "Active", leave: 6, joined: "2022-11-01" },
  { id: "e5", name: "Michael Tetteh", role: "Operations", dept: "Operations", manager: "Nii Ayikwei", status: "Leave", leave: 3, joined: "2021-08-20" },
];

export const onboardingChecklist = [
  { id: "o1", label: "Welcome email sent", done: true },
  { id: "o2", label: "Employment contract signed", done: true },
  { id: "o3", label: "Ghana Card ID verified", done: true },
  { id: "o4", label: "Bank & SSNIT details submitted", done: false },
  { id: "o5", label: "Laptop + phone assigned", done: false },
  { id: "o6", label: "Department & manager assigned", done: true },
  { id: "o7", label: "Product training module 1", done: false },
  { id: "o8", label: "Product training module 2", done: false },
  { id: "o9", label: "Payroll profile activated", done: false },
];

// Executive analytics
export const revenueByMonth = salesTrend;
export const leadFunnel = [
  { stage: "Visitors", value: 4820 },
  { stage: "Leads", value: 612 },
  { stage: "Qualified", value: 244 },
  { stage: "Proposals", value: 118 },
  { stage: "Closed Won", value: 62 },
];
export const departmentPerformance = [
  { dept: "Sales", score: 92 },
  { dept: "Support", score: 88 },
  { dept: "Marketing", score: 84 },
  { dept: "Operations", score: 79 },
  { dept: "Finance", score: 90 },
];

// FAQ suggestions to seed the AI receptionist
export const chatSuggestions = [
  "What does StaffLink Ghana do?",
  "I'd like to book a free consultation",
  "Can you help me automate customer service?",
  "Do you support WhatsApp automation?",
  "I run a restaurant — what can you automate for me?",
];

// Before/after copy for demos
export const beforeAfter = {
  1: {
    before: [
      "Missed enquiries when staff are busy or off-duty",
      "Slow, inconsistent responses across channels",
      "No visibility into what customers actually ask",
    ],
    after: [
      "24/7 AI receptionist on WhatsApp + web chat",
      "Instant, on-brand answers in seconds",
      "Every conversation logged with lead insights",
    ],
  },
  2: {
    before: [
      "Leads scattered across email, WhatsApp and paper",
      "No follow-up until it's too late",
      "Zero visibility into pipeline value",
    ],
    after: [
      "Every enquiry lands in one CRM instantly",
      "AI qualifies + scores each lead automatically",
      "Kanban pipeline shows deal value in real-time",
    ],
  },
  3: {
    before: [
      "Appointments booked over phone calls",
      "Double bookings and no-shows",
      "Manual reminders (or none at all)",
    ],
    after: [
      "Self-service online booking 24/7",
      "Automatic WhatsApp & email reminders",
      "Reschedule and cancel with one tap",
    ],
  },
  4: {
    before: [
      "Quotations typed in Word, sent as email attachments",
      "VAT and discount errors slip through",
      "No visibility into payment status",
    ],
    after: [
      "One-click professional quotation + PDF",
      "VAT & discounts auto-calculated in GHS",
      "Convert quote → invoice → payment tracking",
    ],
  },
  5: {
    before: [
      "Spreadsheets for stock, updated weekly at best",
      "Discovered stock-outs at the till",
      "No idea which products actually make profit",
    ],
    after: [
      "Live stock levels with low-stock alerts",
      "Auto-generated purchase orders",
      "Profit reports and top-product ranking",
    ],
  },
  6: {
    before: [
      "New hires filling paper forms on day one",
      "Contracts, IDs and payslips scattered",
      "Training tracked in someone's head",
    ],
    after: [
      "Digital onboarding checklist per employee",
      "Contracts, IDs and payroll in one place",
      "HR dashboard for the whole company",
    ],
  },
  7: {
    before: [
      "Monthly reports pieced together manually",
      "Leadership makes calls on stale data",
      "No single view of the business",
    ],
    after: [
      "Real-time KPIs across every department",
      "Executive dashboard on any device",
      "One-click Excel & PDF exports",
    ],
  },
};
